module.exports = __webpack_public_path__ + "3cf97837524dd7445e9d1462e3c4afe2.woff";